// extracted by mini-css-extract-plugin
export default {"registerModal":"ChangePasswordModal_registerModal__psHVi","form":"ChangePasswordModal_form__cORWX","input":"ChangePasswordModal_input__hdtWu Tab_input__E+5gn"};